import { createSlice } from "@reduxjs/toolkit";
import { DbOrderItemInfos } from "../../Core/Api/Types/db-order-item-infos";

export interface ReduxStateObjectOrders {
    orders: DbOrderItemInfos[];
    isLoading: boolean;
}

const initialState: ReduxStateObjectOrders = {
    orders: [],
    isLoading: true,
};

export const objectOrdersSlice = createSlice({
    name: "objectOrders",
    initialState,

    reducers: {
        SetLoading: (state, action) => {
            state.isLoading = action.payload;
            console.debug("orders:SetLoading(" + action.payload + ")");
        },
        StoreOrders: (state, action) => {
            state.orders = action.payload;
            console.debug("orders:StoreOrders(" + action.payload.id + ")");
        },
        CancelOrdersByIds: (state, action) => {
            state.orders = state.orders?.filter((x) => !action.payload.find((y) => y === x.id)) || [];
        },
    },
});

export const { SetLoading, StoreOrders, CancelOrdersByIds } = objectOrdersSlice.actions;

export const GetCurrentOrders = (state): DbOrderItemInfos[] => state.orders.orders;
export const IsOrdersLoading = (state): boolean => state.orders.isLoading;

export default objectOrdersSlice.reducer;
